/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Droplinkevent2Inputs */

const en_droplinkevent2 = /** @type {(inputs: Droplinkevent2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event`)
};

const de_droplinkevent2 = /** @type {(inputs: Droplinkevent2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event`)
};

/**
* | output |
* | --- |
* | "Event" |
*
* @param {Droplinkevent2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const droplinkevent2 = /** @type {((inputs?: Droplinkevent2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Droplinkevent2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_droplinkevent2(inputs)
	return de_droplinkevent2(inputs)
});
export { droplinkevent2 as "dropLinkEvent" }